module.exports = [{"id":"hex","displayText":"HEX (#AA1923)"},{"id":"hex2","displayText":"HEX (AA1923)"},{"id":"rgb","displayText":"RGB - (1,2,3)"},{"id":"rgba","displayText":"RGBA - (1,2,3,0.4)"}]


//////////////////
// WEBPACK FOOTER
// ./src/data/formats.json
// module id = IXxU
// module chunks = 1